import React from 'react';
import AddRelever from './AddRelever';

const ReleverPage = () => {
  return (
    <main className="mx-auto max-w-7xl grow">
      <div className="text-neutral-100">
        <div className="grid grid-cols-1 gap-8">
          <AddRelever />
        </div>
      </div>
    </main>
  );
};

export default ReleverPage;
